import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductStockLocation } from '../../../models/ProductStock';

export const CollectionProductStockStatus: React.FC<{
    quantity: ProductStockLocation;
}> = (props) => {
    const { quantity } = props;
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });

    return (
        <Box>
            <Typography sx={{ fontWeight: 'bold' }}>
                {t('PRODUCT.IN_STOCK')}:
            </Typography>
            <Typography sx={{ fontWeight: 'bold' }}>
                {quantity ? quantity.quantity : 0} db
            </Typography>
        </Box>
    );
};
